module.exports = __webpack_public_path__ + "static/media/medical_critical_illness.c9f32d5f.svg";